import { action, computed, observable } from 'mobx'
import moment from 'moment'

import lang from '../i18n'
import UserInfoStore from './UserInfoStore'

//import utils
import {
  getAddressInfoFetchHandler,
  getAreaCleanerceInfoFetchHandler,
  getAreaEquipmentInfoFetchHandler,
  getCleanerWorkInfoFetchHandler,
  getCurrentUserTotalclearance,
  getServiceAccountClearance,
  createDistrictExcelFetchHandler,
  getDistrictIsExist,
  getTargetAndSubordinateDistrict,
  getDeviceTotalWeightByCurrentAccount,
  getCansByCurrentUser,
  newGetAreaEquipmentInfoFetchHandler,
  newGetAddressInfoFetchHandler,
  newGetAreaCleanerceInfoFetchHandler,
} from '../utils/fetchData'

/*
  rightScrollHeight 右边可滚动区域的高度
  rightScrollWidth 右边可滚动区域的宽度
*/

class Store {
  @observable rightScrollHeight = 0
  @observable rightScrollWidth = 0
  @observable pieChartWidth = 0
  @observable lineChartWidth = 0
  @observable lineChartHeight = 0
  @observable cumulativeRecovery = 0
  @observable averageNum = 0
  @observable addressArr = []
  @observable choseAddress = lang.lang('dataAnalysis.chooseArea')
  @observable choseCity = ''
  @observable chosenCityId = ''
  @observable _times = null
  @observable totalPage = 1
  @observable areaPage = 1
  @observable cleanerArr = []
  @observable cleanerNum = 0
  @observable cleanerWorkingNum = 0
  @observable mapCanArr = []
  @observable mapCarArr = []
  @observable areaShowLoading = true
  @observable showChooseReport = false
  @observable isDailyReport = false
  @observable isMonthlyReport = false
  @observable showExportRange = false
  @observable progressIsShow = false
  @observable outerSelectedAddress = 'all'
  @observable outerSelectedLabel = '全部'
  @observable exportSelectedAddress = ''
  @observable exportDateTime = [moment(), moment()]
  @observable exportMonthTime = [moment('2019-1', 'YYYY-MM-DD'), moment()]
  @observable progressNum = 0
  @observable _saveSourceArr = []
  @observable exportDataName = null
  @observable intervalTime = null
  @observable exportTipsShow = false
  @observable exportDataSuceess = true
  @observable exportTipsTxt = '文件创建成功，您可以点击下载按钮来下载文件。'
  @observable subAreaArr = []
  @observable regionId = ''
  @observable preCityId=''

  



  @computed get saveSourceArr() {
    return this._saveSourceArr.map(arr => [
      moment(arr[0]).format('MM-DD'),
      arr[1]
    ])
  }

  @observable _areaChoseArr = []

  @computed get saveElectronArr() {
    return this._saveSourceArr.map(item => [
      moment(item[0]).format('MM-DD'),
      (item[1] * 6).toFixed(1)
    ])
  }

  @computed get saveWaterArr() {
    return this._saveSourceArr.map(item => [
      moment(item[0]).format('MM-DD'),
      (item[1] * 10).toFixed(1)
    ])
  }

  @computed get reducedLandfillArr() {
    return this._saveSourceArr.map(item => [
      moment(item[0]).format('MM-DD'),
      ((item[1] * 2) / 3).toFixed(1)
    ])
  }

  @computed get reducedBurnArr() {
    return this._saveSourceArr.map(item => [
      moment(item[0]).format('MM-DD'),
      ((item[1] * 1) / 3).toFixed(1)
    ])
  }

  @computed get areaChoseArr() {
    let _ = lang._curLang
    return this._areaChoseArr.map((city, num) => ({
      id:city.id,
      city: city.address,
      canNum: city.canNumbers,
      data: this._times.map((item, index) => [
        moment(item).format('MM-DD'),
        (this._areaChoseArr[num].kilograms[index] / 1000).toFixed(1) * 1
      ])
    }))
  }

  @action.bound
  async fetchAnalysisData() {
    if(UserInfoStore.accountIsNotGraded) {
      //非分级账号
      //获取节约资源量
      let eightDayAgo = Date.parse(
        moment()
          .subtract(7, 'days')
          .format('YYYY-MM-DD')
      )
      let oneDayAgo = Date.parse(
        moment()
          .subtract(1, 'days')
          .format('YYYY-MM-DD')
      )
      let str = `startTime=${eightDayAgo}&endTime=${oneDayAgo}&level=COUNTRY`
      try {
        let getAddressInfoFetchHandlerFin
        let getAreaCleanerceInfoFetchHandlerFin
        //地域使用新接口
        if (UserInfoStore.accountUseNewRules) {
          getAddressInfoFetchHandlerFin = newGetAddressInfoFetchHandler()
          getAreaCleanerceInfoFetchHandlerFin=newGetAreaCleanerceInfoFetchHandler(str)
        } else {
          getAddressInfoFetchHandlerFin = getAddressInfoFetchHandler(str)
          getAreaCleanerceInfoFetchHandlerFin=getAreaCleanerceInfoFetchHandler(str)
        }
      
        
        //数据明细使用新接口 
        let [totalRes, areaRes, addressRes] = await Promise.all([
          getCurrentUserTotalclearance(),
          getAreaCleanerceInfoFetchHandlerFin,//获取曲线信息  行政区域的清运信息
          getAddressInfoFetchHandlerFin //获取区域
        ])
        //当前用户清运总量
        if (totalRes.ok) {
          const resBody = await totalRes.json()
          this.fetchTotalSuccess(resBody)
        } 
        //区域清运信息
        if (areaRes.ok) {
          const resBody = await areaRes.json()
          this.fetchAreaClearanceInfoSuccess(resBody)
        }
        //使用新接口
        if (UserInfoStore.accountUseNewRules) {
          const resBody = await addressRes.json()
          this.fetchAddressSuccess(resBody,true)
        } else {
          //位置信息
          if (addressRes.ok) {
            const resBody = await addressRes.json()
            this.fetchAddressSuccess(resBody,false)
          }
        }
      } catch (e) {}
    } else {
      // 分级账号
      try {
        let [totalRes] = await Promise.all([
          getDeviceTotalWeightByCurrentAccount()
        ])
        if(totalRes.ok) {
          const resBody = await totalRes.json()
          this.fetchTotalSuccess(resBody)
        }
      }
      catch(e) {}
    }
  }

  @action fetchAddressSuccess(data,isNewPort) {
    let province = isNewPort?data.content.results:data.content.provinces
    let resultArr = province.map(function(item) {
      return {
        id: item.id,
        name: item.name
      }
    })
    resultArr.unshift({
      id: 'all',
      name: lang.lang('dataAnalysis.chooseArea')
    })
    let arr = []
    for (let i = 0; i < resultArr.length; i++) {
      if (resultArr[i]) {
        arr.push(resultArr[i])
      }
    }
    this.addressArr = arr
  }
  
  @action fetchTotalSuccess(data) {
    this.cumulativeRecovery = (data.content.kilogram / 1000).toFixed(0)
  }
  @action fetchAreaClearanceInfoSuccess(data) {
    let times = data.content.times
    let kilograms = data.content.collects[0].kilograms
    let sum = 0
    let resultArr = times.map(function(item, index) {
      const arr = [item, kilograms[index]]
      sum += kilograms[index]
      return arr
    })
    this.averageNum = sum / 7000
    this._saveSourceArr = resultArr
  }
  //联动部分
  @action.bound
  async fetchLinkage() {
    if(UserInfoStore.accountIsGraded) {
      // 如果是分级账号
      // 请求时开始时间、结束时间必填，开始时间为当前月份往前推四个月
      let startTime = Date.parse(
        moment()
          .subtract(4, 'month')
          .format('YYYY-MM-DD')
      )
      let endTime = Date.parse(moment().format('YYYY-MM-DD'))
      let str
      if (this.outerSelectedAddress === 'all') {
        str = `startTime=${startTime}&endTime=${endTime}&type=MONTH&pageSize=4&pageNumber=${this.areaPage}`
      } else {
        str = `startTime=${startTime}&endTime=${endTime}&type=MONTH&pageSize=4&pageNumber=${this.areaPage}&subordinate=${this.outerSelectedAddress}`
      }
      try {
        let [serviceAccountRes] = await Promise.all(
          [getServiceAccountClearance(str)]
        )
        if (serviceAccountRes.ok) {
          const resBody = await serviceAccountRes.json()
          this.fetchAreaSuccess(resBody)
        }
        //获取所有设备信息
        getCansByCurrentUser(
          
          res => {
            this.mapCanArr.clear()
            this.mapCanArr = res
          })
      } catch (e) { }
    } else {
       //默认获取全部
       //非分级账号，开始时间必填，开始时间为当前月往前推四个月
      let str,
      cleanerStr,
      startTime = Date.parse(
        moment()
          .subtract(4, 'month')
          .format('YYYY-MM-DD')
      )
      let endTime = Date.parse(moment().format('YYYY-MM-DD'))

      if (this.choseAddress === lang.lang('dataAnalysis.chooseArea')) {
        str = UserInfoStore.accountUseNewRules? `startTime=${startTime}&endTime=${endTime}&type=MONTH&size=4&page=${this.areaPage}`:`startTime=${startTime}&level=CITY&type=MONTH&size=4&page=${this.areaPage}`
        cleanerStr = ''
      } else {
        str = UserInfoStore.accountUseNewRules? `startTime=${startTime}&endTime=${endTime}&type=MONTH&regionId=${this.regionId}&size=4&page=${this.areaPage}`:`startTime=${startTime}&level=CITY&type=MONTH&province=${this.choseAddress}&size=4&page=${this.areaPage}`
        cleanerStr =UserInfoStore.accountUseNewRules? `regionId=${this.regionId}`:`province=${this.choseAddress}`
      }

      try {
        this._areaChoseArr.clear()
        let getAreaCleanerceInfoFetchHandlerFin=UserInfoStore.accountUseNewRules?newGetAreaCleanerceInfoFetchHandler(str):getAreaCleanerceInfoFetchHandler(str)
        let [areaRes, cleanerRes] = await Promise.all([
          getAreaCleanerceInfoFetchHandlerFin,
          getCleanerWorkInfoFetchHandler(cleanerStr),
        ])
        
        if (areaRes.ok) {
          const resBody = await areaRes.json()
          this.fetchAreaSuccess(resBody)
        }
        if (cleanerRes.ok) {
          let cleanerResContent = cleanerRes
          const resBody = await cleanerResContent.json()
          this.fetchCleanerSuccess(resBody)
        }
        //获取所有设备信息
        getCansByCurrentUser(
          res => {
            this.mapCanArr.clear()
            this.mapCanArr = res
          })
      } catch (e) {}
    }
  }
  @action fetchEquipmentSuccess(data) {
    this.mapCanArr.clear()
    this.mapCanArr = data.content

  }
  @action fetchCleanerSuccess(data) {
    let arr = data.content
    let workArr = []
    let num = 0
    this.cleanerArr.clear()
    this.mapCarArr.clear()
    arr.sort(function(a, b) {
      return b.count - a.count
    })
    arr.forEach(function(item, index) {
      if (item.state) {
        num++
        workArr.push(item)
      }
    })
    this.cleanerNum = arr.length
    this.cleanerWorkingNum = num
    this.cleanerArr = arr
    this.mapCarArr = workArr
  }

  @action fetchAreaSuccess(data) {
    //左边linechart部分
    this.areaShowLoading = false
    this._times = data.content.times
    this._areaChoseArr = data.content.collects
    this.totalPage = data.content.totalPages
  }

  @action.bound
  async fetchMapAndCleanerData(recentCityId) {
    //第一次点击或者上次和这次点击的不一样获取当前城市的设备
    if(this.preCityId==='' || this.preCityId!==recentCityId){
      this.preCityId=recentCityId
       //默认获取全部
       let cleanerStr = `city=${this.choseCity}`
       try {
         //如果不是分级而且不是有行政区的
           //参数是id
           let shouldUseNewPort=UserInfoStore.accountIsGraded || UserInfoStore.accountUseNewRules
         let getAreaEquipmentInfoFetchHandlerFin = shouldUseNewPort?
           newGetAreaEquipmentInfoFetchHandler(this.chosenCityId)
           : getAreaEquipmentInfoFetchHandler(cleanerStr)

         let [cleanerRes, equipmentRes] = await Promise.all([
           getCleanerWorkInfoFetchHandler(cleanerStr),
           getAreaEquipmentInfoFetchHandlerFin
         ])
         if (cleanerRes.ok) {
           const resBody = await cleanerRes.json()
           this.fetchCleanerSuccess(resBody)
         }
           if (equipmentRes.ok) {
             const resBody = await equipmentRes.json()
             this.fetchEquipmentSuccess(resBody)
           }
           this.areaShowLoading = false
       } catch (e) { }
    // 第二次点击当前城市 地图显示全部地图
    }else{
      this.preCityId=''
      this.fetchLinkage()
    }
    
  }


  @action.bound 
  async createExcel() {
    if(this.isDailyReport) {
      let startTime = this.exportDateTime[0].valueOf()
      let endTime = this.exportDateTime[1].valueOf()
      let str = `startTime=${startTime}&endTime=${endTime}&type=DAY`
      //如果外层没选
      if(this.outerSelectedAddress ==='all') {
        if(this.exportSelectedAddress !== 'all') {
          this.exportSelectedAddress?str += `&subordinate=${this.exportSelectedAddress}`:''
        }
      }else {
        //外层选了
        this.exportSelectedAddress?str += `&subordinate=${this.exportSelectedAddress}`:''
      }
      let res = await createDistrictExcelFetchHandler(str)
      if(res.ok) {
        const resBody = await res.json()
        this.createExcelSuccess(resBody)
      }
    }else {
      let startTime = this.exportMonthTime[0].valueOf()
      let endTime = this.exportMonthTime[1].valueOf()
      let str = `startTime=${startTime}&endTime=${endTime}&type=MONTH`
      if(!this.outerSelectedAddress){
        this.outerSelectedAddress? str += `&subordinate=${this.outerSelectedAddress}`:''
      }else {
        this.exportSelectedAddress? str += `&subordinate=${this.exportSelectedAddress}`:''
      }
      let res = await createDistrictExcelFetchHandler(str)
      if(res.ok) {
        const resBody = await res.json()
        this.createExcelSuccess(resBody)
      }
    }
  }
  @action createExcelSuccess(data) {
    let that = this
    this.exportDataName = data.content
    this.intervalTime = setInterval(function () {
      that.getIsExistFunction()
      if (that.progressNum <= 90) {
        that.progressNum += 20
      }
    }, 1000)
  }

  @action.bound
  async getIsExistFunction() {
    let res = await getDistrictIsExist(this.exportDataName)
    if (res.ok) {
      const resBody = await res.json()
      this.getIsExistSuccess(resBody)
    } else {
      const resBody = await res.json()
      this.getIsExistFail(resBody)
    }
  }

  @action
  getIsExistSuccess(data) {
    if (data.content) {
      clearInterval(this.intervalTime)
      this.progressNum = 0
      this.progressIsShow = false
      this.exportTipsShow = true
      this.exportDataSuceess = true
    }
  }
  @action getIsExistFail(data) {
    clearInterval(this.intervalTime)
    if (data.code === 102) {
      this.exportTipsTxt = lang.lang('dataInfo.TipsPermissionErr')
      this.exportTipsShow = true
    } else if (data.code === 300101) {
      this.exportTipsTxt = lang.lang('dataInfo.TipsBuildFail')
      this.exportTipsShow = true
    } else {
      this.exportTipsTxt = lang.lang('dataInfo.TipsBuildFail')
      this.exportTipsShow = true
    }
  }

  @action fetchSubAreaHandler = () => {
    getTargetAndSubordinateDistrict(
      (res) => {
        let area = res.content.results
        let resultArr = area.map(function(item){
          return {
            id: item.id,
            name: item.name
          }
        })
        resultArr.unshift({
          id: 'all',
          name: lang.lang('dataAnalysis.chooseArea')
        })
        let arr = []
        for (let i = 0; i < resultArr.length; i++) {
          if (resultArr[i]) {
            arr.push(resultArr[i])
          }
        }
        this.subAreaArr = arr
      },
      () => {}
    )
  }

}

let AnalysisStore = new Store()

export default AnalysisStore



// WEBPACK FOOTER //
// ./src/store/AnalysisStore.js